import './Footer.scss'
import React from 'react'
import { mobile } from '../Services/Agent'

function Footer(){

    return(
        <footer>
            <div className="black_line"></div>
            <div className="credits_wrapper">
    {/* <div className="credit">עריכה: יהונתן בני"ה {mobile() ? <br /> : "|" } ניהול תוכן וידיאו: נועה גליקשטיין-קרן וגיא זקהם {mobile() ? <br /> : "|" } לוח אירועים: טלי פרקש</div> */}
    <div className="credit">
    <bold>עריכה:</bold> יהונתן בני"ה { "|" }
    <bold>ניהול תוכן וידיאו:</bold>  נועה גליקשטיין-קרן וגיא זקהם { "|" }
    <bold>לוח אירועים:</bold> טלי פרקש {mobile() ? <br /> : "" } { "|" }
    <bold>יעוץ:</bold> הרב ד"ר חיים בורגנסקי 
    </div>
                {/* <div className="names">תמונות: אורי דוידוביץ', AP, gettyimages, shutterstock</div> */}
                <div className="names"> <bold>תמונות:</bold>  אורי דוידוביץ', AP, gettyimages, shutterstock</div>
            </div>
                <div className="footer-wrapper">
                    <div className="f-item">
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">
                        תנאי שימוש
                        </a>{" "}
                        
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">
                            ומדיניות פרטיות
                        </a>{" "}
                        {" "}
                        |{" "}
                    </div>
                    &nbsp;
                    <div className="f-item">
                        <a href="https://yit.co.il/" target="_blank">
                            עיצוב אפיון ופיתוח 
                            <div className="yit"></div>
                        </a>
                    </div>
                </div>
        </footer>
    )
}

export default Footer;
